module.exports = __webpack_public_path__ + "static/media/future-medicine.5706134d.jpg";